(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
if (!customElements.get("c-cart-recommendation")) {
  customElements.define(
    "c-cart-recommendation",
    class ComponentRecommendations extends HTMLElement {
      constructor() {
        super();

      }

      connectedCallback() {
        this.renderProducts();
      }

      disconnectedCallback() {
        this.btnPrev?.removeEventListener("click", this.prevSlide);
        this.btnNext?.removeEventListener("click", this.nextSlide);
        this.forms?.forEach(form => {
          form.removeEventListener("submit", this.onSubmitHandler);
        })
      }

      initializeSlider = () => {  
        this.wrapper = this.querySelector(".js-cart-recommendation__list-wrapper");
        this.forms = Array.from(this.querySelectorAll(".js-cart-recommendation__form"));

        this.addToCartButtons = Array.from(this.querySelectorAll(".js-cart-recommendation__submit-btn"));

        this.swiper = new Swiper(this.wrapper, {
          slidesPerView: "auto",
          spaceBetween: 12,
          speed: 400,
          slidesOffsetAfter: 40,
        });

        this.btnPrev = this.querySelector(".js-cart-recommendation__button--prev");
        this.btnNext = this.querySelector(".js-cart-recommendation__button--next");

        this.btnPrev?.addEventListener("click", this.prevSlide);
        this.btnNext?.addEventListener("click", this.nextSlide);

        this.forms.forEach(form => {
          form.addEventListener("submit", this.onSubmitHandler.bind(this, form));
        })

        this.slideChange()

        this.swiper.on('slideChange', () => {
          this.slideChange();
        });
      }

      renderProducts = () => {
        this.sectionId = this.dataset.sectionId;
        this.productId = this.dataset.productId;

        fetch(window.Shopify.routes.root + `recommendations/products?product_id=${this.productId}&limit=4&section_id=${this.sectionId}&intent=related`)
        .then(response => response.text())
        .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('c-cart-recommendation');

            this.innerHTML = recommendations?.innerHTML || '';

            this.initializeSlider();
        });
      };

      onSubmitHandler = (form, evt) => {
        evt.preventDefault();  
  
        const config = {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/javascript'
          }
        };
  
        let formData = new FormData(form);
 
        config.body = formData;

        this.addToCartButtons.forEach(btn => {
          btn.setAttribute("disabled", "")
        })
  
        fetch(`${theme.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) return;
  
            window.PubSub.publish("cart:update", "");
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.addToCartButtons.forEach(btn => {
              btn.removeAttribute("disabled")
            })
          });
      }

      slideChange = () => {
        if(this.swiper.isEnd) {
          this.btnNext?.setAttribute("disabled", "")
        } else {
          this.btnNext?.removeAttribute("disabled")
        }

        if(this.swiper.isBeginning) {
          this.btnPrev?.setAttribute("disabled", "")
        } else {
          this.btnPrev?.removeAttribute("disabled")
        }

        if (this.swiper.slides.length == (this.swiper.activeIndex + 1)) {
          this.wrapper?.classList.remove("is-scroll");
          this.btnNext?.setAttribute("disabled", "");
        } else {
          this.wrapper?.classList.add("is-scroll");
          this.btnNext?.removeAttribute("disabled");
        }
      }

      prevSlide = () => {
        this.swiper.slidePrev();
      }

      nextSlide = () => {
        this.swiper.slideNext();
      }
    }
  );
}

},{}]},{},[1])

